import { $, $$ } from '@utils';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-input-phone]')) return;

  addEventListeners();
}

function addEventListeners() {
  $$('[data-au-country-select]').forEach((select) => {
    const selectButtonIcon = select.querySelector('[data-au-icon]');
    const selectOptions = select.closest('[data-au-input-phone').querySelector('[data-au-country-options]');
    const options = selectOptions.querySelectorAll('li');
    const selectedOptionText = select.querySelector('[data-au-country-option]');
    const defaultOption = options[41]; // You can change this to the one you want as default
    const defaultCountryCode = defaultOption.dataset.auCountryCode;
    const defaultFlag = defaultOption.dataset.auFlag;
    const defaultCountryName = defaultOption.dataset.auCountryName;
    selectedOptionText.innerHTML = `<img src="${defaultFlag}" class="au-input-phone__select-flag" alt="${defaultCountryName}" height="12" width="16"> ${defaultCountryCode}`;

    // Toggles visibility of options on button click
    select.addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      const isExpanded = select.getAttribute('aria-expanded') === 'true';
      select.setAttribute('aria-expanded', !isExpanded);
      selectOptions.hidden = isExpanded;
      if (selectButtonIcon.innerHTML === 'expand_more') selectButtonIcon.innerHTML = 'expand_less';
      else selectButtonIcon.innerHTML = 'expand_more';
    });

    // Handle option selection
    options.forEach((option) => {
      option.addEventListener('click', () => {
        const countryCode = option.dataset.auCountryCode;
        const countryFlag = option.dataset.auFlag;
        const countryName = option.dataset.auCountryName;
        const item_id = removeAccentMarkAndUppercase(`country code_${countryName}`);
        selectedOptionText.innerHTML = `<img src="${countryFlag}" class="au-input-phone__select-flag" alt="${countryName}" height="12" width="16"> ${countryCode}`;

        // Update aria-selected state
        options.forEach((opt) => opt.removeAttribute('aria-selected'));
        option.setAttribute('aria-selected', 'true');

        window.dataLayer.push({
          event: 'navigation',
          content_type: 'clickSelector',
          item_id,
        });

        // Close the dropdown
        select.setAttribute('aria-expanded', 'false');
        selectOptions.hidden = true;
        if (selectButtonIcon.innerHTML === 'expand_less') selectButtonIcon.innerHTML = 'expand_more';
      });
    });

    // Handle keyboard navigation
    select.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        selectOptions.hidden = false;
        options[0].focus();
      }
    });

    options.forEach((option, index) => {
      option.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          const nextOption = options[index + 1] || options[0];
          nextOption.focus();
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          const prevOption = options[index - 1] || options[options.length - 1];
          prevOption.focus();
        } else if (e.key === 'Enter') {
          e.preventDefault();
          option.click();
        }
      });

      // Hide listbox after tabulation
      option.addEventListener('blur', () => {
        if (index + 1 === options.length) {
          select.setAttribute('aria-expanded', 'false');
          selectOptions.hidden = true;
          if (selectButtonIcon.innerHTML === 'expand_less') selectButtonIcon.innerHTML = 'expand_more';
        }
      });
    });

    // Close the dropdown when clicking outside of it
    document.addEventListener('click', (e) => {
      if (!select.contains(e.target) && !selectOptions.contains(e.target)) {
        select.setAttribute('aria-expanded', 'false');
        selectOptions.hidden = true;
        if (selectButtonIcon.innerHTML === 'expand_less') selectButtonIcon.innerHTML = 'expand_more';
      }
    });

    document.addEventListener('keyup', (e) => {
      if (e.key === 'Escape') {
        select.setAttribute('aria-expanded', 'false');
        selectOptions.hidden = true;
        if (selectButtonIcon.innerHTML === 'expand_less') selectButtonIcon.innerHTML = 'expand_more';
      }
    });
  });
}

export default { init };
